import axios from 'axios';

export const getPostalData = {
    methods: {
        getPostalData(zipcode, number) {
            return axios.post(
                this.$CLOUD_API + '/postal/autofill',
                {
                    zip: zipcode,
                    number: number
                },
                {
                    headers: {
                        fbAuth: this.$FB_ID_TOKEN,
                        Authorization: 'Bearer ' + this.$store.state.oAuthToken
                    },
                    timeout: 5000 // Timeout after 5 seconds
                }
            );
        }
    },
};
